import React from 'react';

import { Text } from '../../components/Text';
import { variables } from '../variables';

import { getInitialName } from './utils/getInitialName';
import styled, { css } from 'styled-components';

type AvatarProps = {
    children: any;
    showName?: boolean;
    isActive?: boolean;
    kind?: 'default' | 'secondary';
};

const Style = styled.div<{ $isActive?: boolean; $kind?: 'default' | 'secondary' }>`
    &&& {
        display: inline-flex;
        align-items: center;

        .avatar-icon-wrapper {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            border: 1px solid ${(props) => variables.colors[props.$isActive ? 'brand-primary-blue' : 'road-grey-700']};

            border-radius: 9999px;

            ${(props) =>
                props.$kind === 'secondary' &&
                css`
                    width: 64px;
                    height: 64px;
                    border: 1px solid transparent;
                    background-color: #f0f2f5;
                `}
        }

        .avatar-name-wrapper {
            margin-left: 4px;
        }
    }
`;

export const Avatar: React.FC<AvatarProps> = ({
    children,
    showName = false,
    isActive = false,
    kind = 'default',
}: AvatarProps) => {
    return (
        <Style $kind={kind} $isActive={isActive}>
            <div className="avatar-icon-wrapper">
                <Text
                    color={isActive ? 'brand-primary-blue' : 'road-grey-700'}
                    size={kind === 'secondary' ? '18' : '9'}
                    weight="700"
                >
                    <strong>{getInitialName(children)}</strong>
                </Text>
            </div>

            {showName ? (
                <div className="avatar-name-wrapper">
                    <Text color="road-grey-700" size="12" weight="500">
                        {children}
                    </Text>
                </div>
            ) : null}
        </Style>
    );
};
